export default __webpack_public_path__ + "static/media/zwave.0bf193f2.svg";